import { cn } from '@/lib/utils'

const sizeClasses = {
	sm: 'h-4 w-4',
	md: 'h-8 w-8',
	lg: 'h-12 w-12',
} as const

interface LoadingSpinnerProps {
	size?: 'sm' | 'md' | 'lg'
	className?: string
}

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
	return <div className={cn('animate-spin rounded-full border-b-2 border-primary', sizeClasses[size], className)} />
}
